/**
 * Double-submit CSRF token. The API sets the readable `stp_csrf` cookie at
 * sign-in; every state-changing request echoes it in X-CSRF-Token, and the API
 * checks it against the server-side session. The session cookie itself is
 * HttpOnly and never visible to scripts.
 */
export const CSRF_COOKIE = "stp_csrf"
export const CSRF_HEADER = "X-CSRF-Token"

export function csrfToken(): string | null {
  const match = document.cookie.split("; ").find((c) => c.startsWith(`${CSRF_COOKIE}=`))
  return match ? decodeURIComponent(match.slice(CSRF_COOKIE.length + 1)) : null
}
